<template>
  <div>
    <div class="has-text-weight-semibold">
      Upload Invoice
    </div>
    <!-- Error -->
    <div v-if="('general' in errors)" class="mb-md">
      <p class="has-text-danger">{{ errors.general }}</p>
    </div>
    <div class="mt-md">
      <!-- Details -->
      <p class="is-size-7">Upload an 810 Invoice file for your sample items orders.</p>
      <ul class="mt-md is-size-7">
        <li>1. Log in to your FTP client and upload the 810 file into your outbox.</li>
        <li>2. Wait for a few minutes for the file to be processed. Click refresh to update invoice status.</li>
        <li>3. Click Confirm & Continue when all the order statuses are invoiced.</li>
        <li>4: Click to download EDI 810 Sample File and Specs.</li>
      </ul>
      <p class="mt-md is-size-7 has-text-grey">NOTE: If your connection has Auto-invoicing enabled, the order will be invoiced automatically within a few seconds and you don’t need to take any action.</p>
      <!-- Note if Address doesn't exist -->
      <div class="mt-sm">
        <div v-if="loadingAddresses"><loading message="Loading billing address details..." /></div>
        <b-message v-if="!loadingAddresses && !billingAddressExists" type="is-danger" has-icon>
          You do not have a billing address configured. Please add a billing address in tasks to continue.
        </b-message>
      </div>
      <!-- FTP Details -->
      <div>
        <LoginDetails :ediAccount="ediAccount" :collapse="true" />
      </div>
      <div v-if="!loadingAddresses && billingAddressExists" class="mt-md">
        <div class="columns is-vcentered is-size-7" @click="loadOrders()">
          <div class="column is-clickable">
            <b-icon icon="refresh" custom-class="mdi-rotate-180" size="is-small"></b-icon>
            <span>Refresh Orders</span>
          </div>
        </div>
        <b-table
          :data="orders"
          :mobile-cards="false"
          :loading="loading"
          class="is-tall is-size-7 border rounded-md"
        >
        <template>
          <!-- PO# -->
          <b-table-column
            label="PO#"
            cell-class="nowrap"
            v-slot="props">
            {{ props.row.purchase_order_number }}
          </b-table-column>
          <!-- Invoice Status -->
          <b-table-column
            label="Invoice Status"
            cell-class="nowrap"
            centered
            v-slot="props">
            <p v-if="props.row.invoice_count === 0">Not invoiced</p>
            <p v-else><MerchantStatus :invoice="props.row" /></p>
          </b-table-column>
        </template>
          <template #empty>
            <div class="py-xxl has-text-grey has-text-centered">
              {{ (loading) ? "Loading data..." : 'No orders found!' }}
            </div>
          </template>
        </b-table>
      </div>
       <!-- Navigate -->
       <div class="py-lg">
        <div class="columns">
          <div class="column">
            <b-button
              type="is-light rounded-lg"
              expanded
              @click="goBack"
              ><b-icon icon="arrow-left"></b-icon>
            </b-button>
          </div>
          <div class="column">
            <b-button
              type="is-primary rounded-lg"
              expanded
              :disabled="loading || !isInvoiced || !billingAddressExists"
              :loading="isUpdating"
              @click="goForward"
            >Confirm & Continue</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoginDetails from '../components/EdiAccount/LoginDetails'
import MerchantStatus from '@/components/Presenters/Invoice/MerchantStatus'
export default {
  components: {
    MerchantStatus,
    LoginDetails
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return this.context.route + '/orders/'
    },
    fields () {
      const base = [
        'id',
        'purchase_order_number',
        'fulfill_by',
        'order_lines',
        'invoice_count',
        'status',
        'received_at',
        'acknowledged_at',
        'retailer'
      ]
      return base
    }
  },
  data () {
    return {
      loading: true,
      loadingAddresses: true,
      errors: {},
      orders: [],
      isUpdating: false,
      isInvoiced: false,
      billingAddress: [],
      billingAddressExists: false
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'onboarding.tasks.self-serve-edi.fulfillment', params: { connection: this.$route.params.connection } })
    },
    goForward () {
      // Add info to the task to track the tasks
      const taskBody = (typeof this.task.info === 'object') ? { info: this.task.info } : { info: {} }
      taskBody.info.uploadInvoices = true
      this.$emit('task:updated', taskBody, 'onboarding.tasks.self-serve-edi.complete')
    },
    loadOrders () {
      this.loading = true
      const query = {
        params: {
          order_by: '-id',
          skip_attributes: 1,
          fields: this.fields
        }
      }
      this.$http.get(this.endpoint, query).then(response => {
        this.orders = response.data.results.filter(el => this.orderIds.includes(el.id))
        // currently validating the status of orders to be closed
        this.isInvoiced = this.orders.filter(el => el.status === 'closed').length === this.orders.length
      }).finally(() => {
        this.loading = false
      })
    },
    loadBillingAddresses () {
      const endpoint = this.context.route + '/locations/?type=billing'
      this.$http.get(endpoint).then(response => {
        this.billingAddress = response.data.results
        this.billingAddressExists = this.billingAddress.length
        if (this.billingAddressExists) {
          this.loadOrders()
        }
      }).finally(() => {
        this.loadingAddresses = false
      })
    }
  },
  mounted () {
    this.orderIds = this.task.info.orderIds
    this.loadBillingAddresses()
  },
  props: {
    connection: {
      type: Object,
      required: true
    },
    ediAccount: {
      type: Object
    },
    task: {
      type: Object,
      required: true
    },
    isUpdatingTask: {
      type: Boolean
    }
  },
  watch: {
    isUpdatingTask (value) {
      this.isUpdating = value
    }
  }
}
</script>
